import { gql } from '@apollo/client';

export default gql`
  query me {
    me {
      paymentLocation @client
      paymentCurrencies
      offices {
        name
        description
        defaultPaymentLocation
        isStation
      }
    }
  }
`;
